import { getCurrentInstance } from 'vue';

export const useGtm = () => {
  try {
    const instance = getCurrentInstance();
    return { sendGtmEvent: instance.proxy.$sendGtmEvent };
  } catch (error) {
    console.error(error);
  }
};
